/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Compare_CtaInputs */

const en_fc_home_compare_cta = /** @type {(inputs: Fc_Home_Compare_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the full comparison`)
};

/**
* | output |
* | --- |
* | "See the full comparison" |
*
* @param {Fc_Home_Compare_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_compare_cta = /** @type {((inputs?: Fc_Home_Compare_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Compare_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_compare_cta(inputs)
});
export { fc_home_compare_cta as "fc.home.compare.cta" }